import React from 'react'
import { Form } from 'semantic-ui-react'

/**
 * @param {object} props
 * @param {function} props.onChange
 * @param {string=} props.className
 * @param {string} props.iconSizeLabel
 */
export default function EmbedCodeRatingIconSizeForm({ onChange, className, iconSizeLabel }) {
  function handleChange(_, { value }) {
    onChange(value)
  }

  return (
    <Form className={className}>
      <label className="bold">Icon size</label>
      <Form.Group inline className="mt2">
        <Form.Checkbox
          checked={iconSizeLabel === 'small'}
          onChange={handleChange}
          radio
          value="small"
          label="Small"
          name="ratingIconSize"
        />
        <Form.Checkbox
          checked={iconSizeLabel === 'medium'}
          onChange={handleChange}
          radio
          value="medium"
          label="Medium"
          name="ratingIconSize"
        />
        <Form.Checkbox
          checked={iconSizeLabel === 'large'}
          onChange={handleChange}
          radio
          value="large"
          label="Large"
          name="ratingIconSize"
        />
      </Form.Group>
    </Form>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/EmbedCodeRatingIconSizeForm/index.js